/**
 * Arrow-key stepping for the Spotlight list.
 * Rows [0, leftCount) are the recent column; the rest is the main column.
 */

export type StepSpotlightIndexArgs = {
  current: number;
  delta: 1 | -1;
  leftCount: number;
  rightCount: number;
  /** True when the main-column row at this flat index is a nested contextual action. */
  isNestedRow: (flatIndex: number) => boolean;
  /** Alt-stepping walks nested rows too; plain arrows jump hit-to-hit. */
  includeNested: boolean;
};

export const stepSpotlightIndex = ({
  current,
  delta,
  leftCount,
  rightCount,
  isNestedRow,
  includeNested,
}: StepSpotlightIndexArgs): number => {
  if (current < leftCount) {
    if (leftCount === 0) return current;
    return (current + delta + leftCount) % leftCount;
  }
  if (rightCount === 0) return current;

  let local = current - leftCount;
  for (let step = 0; step < rightCount; step += 1) {
    local = (local + delta + rightCount) % rightCount;
    const candidate = leftCount + local;
    if (includeNested || !isNestedRow(candidate)) return candidate;
  }
  return current;
};
